import {Component, OnInit, EventEmitter, ViewEncapsulation, Output, Input} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { QuestionnaireService } from '../../services/questionnaire/questionnaire.service';
import { AlertBannerService, AlertType } from "../../lib/alert-banner";
import {OrganisationService} from "../../services/organisation/organisation.service";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import * as Cookies from 'js-cookie';
import {FilterPopupComponent} from "../filter-popup/filter-popup.component";
import { Observable } from 'rxjs';
import {tap} from "rxjs/operators";

@Component({
  selector: 'app-survey-user-permission-modal',
  templateUrl: './survey-user-permission-modal.component.pug',
  styleUrls: ['./survey-user-permission-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SurveyUserPermissionModalComponent implements OnInit {
  @Input() isNewQuestionnaire: boolean = false;
  userlogged_in: any;
  questionnaireId ='';
  questionnaireTitle ='';
  questionnaireProduct ='';
  created_by:any;
  masterRoles: any = ["owner", "support", "Administrator"]
  rowsInput = [20, 50, 100];
  users: any[] = [];
  totalUsers = 0;
  usersPermissionMapping = new Map();
  toggleMapping = new Map();
  loaded = false;
  selectAll = false;
  clearAll = true;
  searchOptions = [{'label':$localize`Name`,'value':'name', 'hint':$localize`Specific name`},
    {'label':$localize`Job title`,'value':'job_title', 'hint':$localize`Specific job title`},];
  searchOptionsCustom = [{'label':$localize`Name`,'value':'name', 'hint':$localize`First or last name`},
    {'label':$localize`Email`,'value':'email', 'hint':$localize`Email address`},
    {'label':$localize`Team`,'value':'team', 'hint':$localize`Team name`},];
  searchTags: any = [];
  sortOptions=[{'label':$localize`User name`, 'type': "word", 'value':'name'}, {'label':$localize`Last login`, 'type': "number", 'value':'last_login'}, ];
  sortOptionsCustom=[{'label':$localize`Email address`, 'type': "word", 'value':'email'}, {'label':$localize`Name`, 'type': "word", 'value':'name'}, ];
  rowsPerView=20;
  currentPage=1;
  filterOptions=[{'label':$localize`Owner`, 'value':'owner'},{'label':$localize`Admin`, 'value':'admin'},{'label':$localize`Member`, 'value':'member'},{'label':$localize`Member (restricted)`, 'value':'member (restricted)'}]
  sortText: any[] = ['-last_login'];
  filters: any = [];
  searchOutput: any = undefined;
  onSave = new EventEmitter();
  onCancel = new EventEmitter();
  dropdownOptions: any[] = [
    {'key': 'Restricted', 'value': $localize`Restricted`},
    {'key': 'Everyone', 'value': $localize`Everyone`},
  ];
  selectedAccess = 'Restricted';
  dropdownLabel = $localize`Restricted`;
  bannerType = 'amber-banner'
  bannerIcon = 'https://assets.xref.com/omni/shared/lock.svg';
  bannerText = '';
  orgName = '';
  access_mapping = QuestionnaireService.access_mapping;
  filterPopupComponent: BsModalRef = new BsModalRef();
  initialSelectedAccess = '';
  isSaveButtonDisabled = true;
  initialUsersState: any;
  roleMapping = {
    0: "None",
    1: "Integration User",
    2: "Administrator",
    3: "Requestor",
    4: "Contributor",
    5: "Analyst"
  };

  productMapping = {
    "Reference": "References",
    "Pulse": "Pulses",
    "Exit": "Exits",
  }
  bannerValue: any = ''


  constructor(private questionnaireService: QuestionnaireService,
              private alertList: AlertBannerService,
              private permission: PermissionsService,
              private organisationService: OrganisationService,
              public bsModalRef: BsModalRef,
              public modalService: BsModalService,) { }

  ngOnInit(): void {
    this.orgName = this.organisationService.getOrganisationBrandName();
    this.bannerText = $localize`Only the ${this.orgName} users selected below can access this survey.`;
    if(this.questionnaireId){
      this.sortText = ['email']
      this.initialiseUsersWithSurveyPermissions().subscribe(() => {
      });
    }
    if(!this.created_by){
      this.userlogged_in = Cookies.get('user_uid');
      this.created_by = {'uid': this.userlogged_in};
    }
    // Enable save button for new questionnaires
    if (this.isNewQuestionnaire) {
      this.isSaveButtonDisabled = false;
    }
  }

  cancel(){
    this.onCancel.emit({data:"ok"});
    this.bsModalRef.hide();
  }

  savePermissions() {
    let userPermission: any[] = [];
    this.usersPermissionMapping.forEach((user, uid) => {
        user['has_permission'] = this.usersPermissionMapping.get(uid).has_permission
        userPermission.push(user)
      });
    this.questionnaireService.putQuestionnairePermissionAccess(
      this.questionnaireId, {'access': this.access_mapping[this.selectedAccess]}
    ).subscribe(res => {
      if (this.selectedAccess === 'Everyone') {
        this.onSave.emit({data: "ok"});
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! Survey permissions have been updated.`,
          keepOnRouteChange: true
        }]);
      }
    }, error => {
      this.onCancel.emit({data: "ok"});
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });

    this.bsModalRef.hide();

    if (this.selectedAccess !== 'Everyone') {
      this.questionnaireService.updateQuestionnaireUsersPermission(this.questionnaireId, {'users': userPermission}).subscribe(res => {
        this.onSave.emit({data: "ok"});
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! Survey permissions have been updated.`,
          keepOnRouteChange: true
        }]);
      }, error => {
        this.onCancel.emit({data: "ok"});
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
      this.bsModalRef.hide();
    }
  }


  addAllUsers() {
    this.loaded = false;
    this.questionnaireService.getUsersWithSurveyPermissions(
      this.questionnaireId, this.searchOutput, this.filters, this.totalUsers, 1, '').subscribe(res => {
      this.loaded = true;
      const allusers = res['data']['users'];
      allusers.forEach((user) => {
        this.changePermissionsUpdated(user, true);
      });
      this.users.forEach((user) => {
        user['has_permission'] = true;
      });

      this.selectAll = true;
      this.clearAll = false;
    });
  }

  removeAllUsers() {
    this.loaded = false;
    this.questionnaireService.getUsersWithSurveyPermissions(
      this.questionnaireId, this.searchOutput, this.filters, this.totalUsers, 1, '').subscribe(res => {
      this.loaded = true;
      const allusers = res['data']['users'];
      allusers.forEach((user) => {
        if (!this.masterRoles.includes(user.role)) this.changePermissionsUpdated(user, false);
      });
      this.users.forEach((user) => {
        if (!this.masterRoles.includes(user.role)) user['has_permission'] = false;
      });

      this.selectAll = false;
      this.clearAll = true;
    });
  }

  onPageChangePaginate(event){
    this.loaded = false;
    let offset = event.page*this.rowsPerView;
    this.currentPage = event.page;
    this.initialiseUsersWithSurveyPermissions().subscribe();
  }


  changePermissionsUpdated(user, has_permission){
    user['has_permission'] = has_permission
    this.usersPermissionMapping.set(user.uid, user);
    this.checkIfValueChanged()
  }

  onSortChange(sortString) {
    this.sortText = [sortString];
    this.initialiseUsersWithSurveyPermissions().subscribe()


  }

  onSearchChangeCustom(searchOutput){
    this.loaded = false
    this.searchTags = [...this.searchTags]
    this.searchTags.unshift(searchOutput)
    this.searchOutput = this.createSearchOption()
    this.initialiseUsersWithSurveyPermissions().subscribe();
  }

  onRemoveSearchTag(searchOutput){
    this.loaded = false
    this.searchTags = searchOutput
    this.searchOutput = this.createSearchOption()
    this.initialiseUsersWithSurveyPermissions().subscribe()
  }

  createSearchOption(): { key: string; value: string }[] {
    return this.searchTags.map(item => ({
      key: item.value === '' ? 'all' : item.value,
      value: item.term
    }));
  }

  onPageChange(pageNumber) {
    this.loaded = false;
    this.currentPage = pageNumber;
    this.initialiseUsersWithSurveyPermissions().subscribe();
  }

  onPageSizeChange(pageSize) {
    this.loaded = false;
    this.rowsPerView = pageSize;
    this.currentPage = 1;
    this.initialiseUsersWithSurveyPermissions().subscribe();
  }

  initialiseUsersWithSurveyPermissions(): Observable<any> {
    return this.questionnaireService.getUsersWithSurveyPermissions(
      this.questionnaireId,
      this.searchOutput,
      this.filters,
      this.rowsPerView,
      this.currentPage,
      this.sortText
    ).pipe(
      tap((res) => {
        this.loaded = true;
        this.users = res['data']['users'];
        if (!this.initialUsersState) {
          this.initialUsersState = new Map();
        }
        const user_uid = Cookies.get('user_uid');
        this.users.forEach(user => {
          this.initialUsersState.set(user.uid, user.has_permission);
          user.isDisabled = user.uid === user_uid;
          if (this.usersPermissionMapping.has(user.uid)) {
            user.has_permission = this.usersPermissionMapping.get(user.uid).has_permission;
          }
        });
        this.totalUsers = res['data']['total'];

        if (res['data']['access']) {
          this.initialSelectedAccess = res['data']['access'];
          if (this.bannerValue) {
            res['data']['access'] = this.bannerValue;
          }
          this.selectAccessPermission({'key': res['data']['access']});
          this.dropdownLabel = this.selectedAccess === 'Everyone' ? $localize`Everyone` : $localize`Restricted`;
        }
      })
    );
  }

  selectAccessPermissionBannerUpdate(event) {
    this.bannerValue = event['key']
    this.selectAccessPermission(event)
  }

  selectAccessPermission(event) {
    if (event['key'] === 'Everyone') {
      this.bannerIcon = 'https://assets.xref.com/omni/shared/lock_open_green.svg'
      this.bannerType = 'forest-banner';
      this.bannerText = $localize`All current and future users with ${this.questionnaireProduct} permission can access this survey.`;
      this.selectedAccess = 'Everyone';
    } else {
      this.bannerIcon = 'https://assets.xref.com/omni/shared/lock.svg'
      this.bannerType = 'amber-banner';
      this.bannerText = $localize`Only selected users can access this survey, provided they have ${this.questionnaireProduct} permission`;
      this.selectedAccess = 'Restricted';
    }
    this.checkIfValueChanged();

  }

  translateSurveyUserRole(user_role)
  {
    let userRoles = [{'label':$localize`Owner`, 'value':'owner'},
      {'label':$localize`Admin`, 'value':'Administrator'},
      {'label':$localize`Requestor`, 'value':'Requestor'},
      {'label':$localize`Xref Support`, 'value':'support'},
      {'label':$localize`Contributor`, 'value':'Contributor'},
      {'label':$localize`Analyst`, 'value':'Analyst'},
      {'label':$localize`Integration`, 'value':'Integration User'}]
    if (user_role) {
      for (let i = 0; i < user_role.length; i++) {
        if (userRoles[i].value == user_role) {
          return userRoles[i].label;
        }
      }
    }
    return ' - '
  }

  translateTeams(teams)
  {
    if (teams) {
      return teams.join(', ');
    }
    else return ' - '

  }

  checkOverflow(element: any): boolean {
    return element.offsetWidth < element.scrollWidth;
  }

  onSelect(selection){
    this.loaded = false;
    this.rowsPerView = Number(selection);
    this.currentPage=1;
    this.initialiseUsersWithSurveyPermissions().subscribe();
    return false;
  }
  applyfilterPopup(event) {
    this.loaded = false;
      const newMapping = event;
      this.filters = [];

      const hasTrueValue = Array.from(this.toggleMapping.values()).some(value => value === true);

      if (hasTrueValue) {
        newMapping.forEach((value, key) => {
          this.toggleMapping.set(key, value);
        });
      } else {
        this.toggleMapping = newMapping;
      }

      this.toggleMapping.forEach((value, key) => {
        if (value === true) {
          this.filters.push(key);
        }
      });

      this.initialiseUsersWithSurveyPermissions().subscribe();
  }


  isRoleDisabled(role) {

    const roleMapping = {
          'Owner': 'owner',
          'Xref Support': 'support'
        };

    return !!this.masterRoles.includes(roleMapping[role] || role);
  }
  checkIfValueChanged() {
    const isDropdownChanged = this.selectedAccess !== this.initialSelectedAccess;
    const isCheckboxesChanged = Array.from(this.usersPermissionMapping.keys()).some(uid => this.initialUsersState.get(uid) !== this.usersPermissionMapping.get(uid).has_permission);
    // For new questionnaires, keep save button enabled even if no changes detected
    // For existing questionnaires, enable only when changes are detected
    const shouldEnable = this.isNewQuestionnaire || isDropdownChanged || isCheckboxesChanged;
    this.toggleSaveButton(shouldEnable);
  }

  toggleSaveButton(enable: boolean): void {
    this.isSaveButtonDisabled = !enable;
  }

  getRoleForProduct(roleData: any, productName: string) {
    if (roleData.role === "member") {
      const productNumber = roleData.products[productName];
      return this.roleMapping[productNumber] || null;
    }
    else if (roleData.role === 'owner' || roleData.role === 'support') {
      return roleData.role
    }
  }

}
